<template>
  <section class="sec_winner_fashion image-text-grid-sec">
    <div class="big_container">
      <div class="sec_content">
        <!-- Section text -->
        <div class="sec_text">
          <h2 class="sec_heading" v-html="shopifyData.secHeading" />
          <h3 class="card_heading_b" v-html="shopifyData.secSubHeading" />
          <p class="body_text" v-html="shopifyData.secInfo" />
        </div>
        <!-- Section Image -->
        <div class="sec_slider">
          <img
            :src="shopifyData.image"
            alt="Section Image"
            loading="lazy"
            aria-hidden="true"
            aria-label="Section Image"
            width=""
            height=""
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    // console.log("Component mounted with data:", this.shopifyData);
  },
};
</script>

<style scoped>
.sec_winner_fashion {
  padding: 30px 0 30px;
}
.sec_content {
  display: grid;
  grid-template-columns: 47.5% 47.5%;
  align-items: center;
  gap: 52px;
}
.sec_text {
  max-width: 453px;
  width: 100%;
  margin: 0 auto;
}
.sec_slider img {
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  display: block;
}

.sec_heading {
  line-height: 41px;
  max-width: 370px;
  width: 100%;
}
.card_heading_b {
  text-transform: initial;
  margin: 14px 0;
}
.body_text {
  line-height: 19px;
}
.swiper {
  padding: 0 55px;
}

/* Responsive Css Code */
@media screen and (max-width: 991px) {
  .sec_winner_fashion {
    padding: 80px 0 50px;
  }
  .sec_winner_fashion .big_container {
    padding: 0;
  }
  .sec_winner_fashion .sec_content {
    grid-template-columns: 100%;
  }
  .sec_slider {
    order: 1;
  }
  .sec_heading {
    margin-bottom: 25px;
  }
  .sec_text {
    max-width: 100%;
    padding: 0 20px;
  }
}

@media screen and (max-width: 767px) {
  .sec_winner_fashion {
    padding: 20px 0 36px;
  }
  .sec_heading {
    margin-bottom: 18px;
    text-align: start;
  }
  .swiper {
    padding: 0 30px;
  }
}
</style>
